export enum MeasureFrom {
  ALL = 0,
  SMS = 1,
  ONLY_MEASURE = 2
}
